import styled from "styled-components";

export const StyledExtensionIframeSalesforce = styled.iframe`
    width: 460px;
    height: 99%;
    background-color: #fff;
    border: none;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
`;

export const StyledExtensionIframeSidebar = styled.iframe<{ isOpen: boolean }>`
    display: block;
    position: fixed;
    box-sizing: border-box;
    width: 460px;
    height: 100vh;
    min-width: 460px;
    top: 0;
    transition: right 0.5s ease-out;
    left: unset;
    margin: 0;
    z-index: 999999;
    background-color: #fff;
    box-shadow:
        0 4px 16px rgba(155, 155, 155, 0.25),
        0 4px 15px rgba(0, 0, 0, 0.25);
    border-radius: 16px 0 0 0;
    border: 0;
    right: ${({ isOpen }) => (isOpen ? "0" : "-460px")};
`;
